import { createFileRoute } from "@tanstack/react-router";

import { BlogCategoryPage, categoryHead, guardPage } from "../components/blog/BlogCategoryPage";
import { pageCount, postsForCategory } from "../components/blog/BlogListing";

const BASE_PATH = "/blog/technology";

export const Route = createFileRoute("/blog/technology/page/$page")({
  loader: ({ params }) => ({
    page: guardPage(BASE_PATH, params.page, pageCount(postsForCategory("technology").length)),
  }),
  head: ({ loaderData }) => categoryHead("technology", loaderData?.page ?? 2),
  component: CategoryPageRoute,
});

function CategoryPageRoute() {
  const { page } = Route.useLoaderData();
  return <BlogCategoryPage categoryKey="technology" page={page} />;
}
